(function(SK){
var computeKundli = SK.computeKundli, fmtDeg = SK.fmtDeg;
var root = document.querySelector("[data-satyug-kundli]");
if (!root) return;
var state = {
step: 1,
birth: { name: "", date: "", time: "", place: "", latitude: null, longitude: null, tzOffsetMinutes: null, timezone: "" },
contact: { name: "", email: "", phone: "", whatsapp: true, consent: true },
kundli: null,
submitting: false,
error: null,
suggestions: [],
suggestOpen: false,
dashaOpen: null
};
function h(tag, attrs, kids) {
var el = document.createElement(tag);
if (attrs) Object.keys(attrs).forEach(function(k) {
if (k === "class") el.className = attrs[k];
else if (k === "style") el.setAttribute("style", attrs[k]);
else if (k.slice(0,2) === "on") el.addEventListener(k.slice(2).toLowerCase(), attrs[k]);
else if (k === "html") el.innerHTML = attrs[k];
else if (attrs[k] === true) el.setAttribute(k, "");
else if (attrs[k] !== false && attrs[k] != null) el.setAttribute(k, attrs[k]);
});
(Array.isArray(kids) ? kids : (kids != null ? [kids] : [])).forEach(function(c) {
if (c == null || c === false) return;
el.appendChild(typeof c === "string" || typeof c === "number" ? document.createTextNode(String(c)) : c);
});
return el;
}
function render() {
root.innerHTML = "";
var wrap = h("div", { class: "sk-wrap" }, [
renderHead(), renderSteps(),
state.step === 1 ? renderBirth() : (state.step === 2 ? renderContact() : renderResults())
]);
root.appendChild(wrap);
}
function renderHead() {
return h("div", { class: "sk-head" }, [
h("span", { class: "sk-chip" }, "Satyug Lifestyle · Free Kundli"),
h("h1", { class: "sk-h1" }, "Your Vedic Birth Chart"),
h("p", { class: "sk-sub" }, "Free Kundli, horoscope, dosha check & dasha timeline — a gift from Satyug Lifestyle.")
]);
}
function renderSteps() {
var items = [{n:1,l:"Birth Details"},{n:2,l:"Contact"},{n:3,l:"Your Kundli"}];
var kids = [];
items.forEach(function(it, i) {
kids.push(h("div", { style: "display:flex;align-items:center;gap:8px;" }, [
h("div", { class: "sk-step-dot" + (state.step === it.n ? " sk-active" : state.step > it.n ? " sk-done" : "") }, state.step > it.n ? "✓" : it.n),
h("span", { class: "sk-step-label" + (state.step >= it.n ? " sk-on" : "") }, it.l)
]));
if (i < items.length - 1) kids.push(h("div", { class: "sk-sep" }));
});
return h("div", { class: "sk-steps" }, kids);
}
function renderBirth() {
var b = state.birth;
var placeInput = h("input", {
class: "sk-input", placeholder: "Start typing your city…",
value: b.place, autocomplete: "off",
oninput: function(e) {
state.error = null;
state.birth.place = e.target.value;
state.birth.latitude = null; state.birth.longitude = null;
state.birth.tzOffsetMinutes = null; state.birth.timezone = "";
clearTimeout(root._geoT);
var q = e.target.value.trim();
if (q.length < 2) { state.suggestions = []; state.suggestOpen = false; return renderSuggest(); }
root._geoT = setTimeout(function() {
fetch("https://geocoding-api.open-meteo.com/v1/search?count=6&language=en&format=json&name=" + encodeURIComponent(q))
.then(function(r) { return r.json(); })
.then(function(data) {
state.suggestions = (data.results || []).map(function(r) {
return { label: [r.name, r.admin1, r.country].filter(Boolean).join(", "), latitude: r.latitude, longitude: r.longitude, timezone: r.timezone };
});
state.suggestOpen = true;
renderSuggest();
}).catch(function() { state.suggestOpen = false; renderSuggest(); });
}, 350);
}
});
var suggestUl = h("ul", { class: "sk-suggest sk-hidden" });
root._suggestUl = suggestUl;
return h("div", { class: "sk-card" }, [
h("div", { style: "text-align:center;margin-bottom:16px;" }, h("span", { class: "sk-chip" }, "Step 1 · Janma Vivaran")),
h("h2", { class: "sk-title" }, "Your Birth Details"),
h("p", { class: "sk-caption" }, "The four sacred coordinates: when you arrived, and where."),
h("div", { class: "sk-grid" }, [
h("div", null, [
h("label", { class: "sk-label" }, "Full Name"),
h("input", { class: "sk-input", placeholder: "e.g. Aarav Sharma", value: b.name, oninput: function(e) { state.birth.name = e.target.value; state.error = null; } })
]),
h("div", null, [
h("label", { class: "sk-label" }, "Date of Birth"),
h("input", { class: "sk-input", type: "date", max: new Date().toISOString().slice(0,10), value: b.date, oninput: function(e) { state.birth.date = e.target.value; } })
]),
h("div", null, [
h("label", { class: "sk-label" }, "Time of Birth"),
h("input", { class: "sk-input", type: "time", step: 60, value: b.time, oninput: function(e) { state.birth.time = e.target.value; } }),
h("p", { class: "sk-hint" }, "As accurate as possible — even 15 min shifts the Lagna.")
]),
h("div", { class: "sk-place-wrap" }, [
h("label", { class: "sk-label" }, "Place of Birth"),
placeInput, suggestUl,
b.latitude != null ? h("p", { class: "sk-hint", style: "color:var(--sk-gold-soft);" }, "✓ " + (b.timezone || "") + " · offset " + ((b.tzOffsetMinutes||0)/60).toFixed(2) + "h") : null
])
]),
state.error ? h("p", { class: "sk-error" }, state.error) : null,
h("div", { class: "sk-actions" }, h("button", { class: "sk-btn-gold", onclick: nextFromBirth }, "Continue →")),
h("p", { class: "sk-privacy" }, "Your data stays private. Used only to compute your chart.")
]);
}
function renderSuggest() {
var ul = root._suggestUl; if (!ul) return;
ul.innerHTML = "";
if (!state.suggestOpen || !state.suggestions.length) { ul.classList.add("sk-hidden"); return; }
ul.classList.remove("sk-hidden");
state.suggestions.forEach(function(s) {
var li = h("li", null, h("button", { type: "button", onclick: function() {
var iso = (state.birth.date || "2000-01-01") + "T" + (state.birth.time || "12:00") + ":00";
var off = tzOffset(s.timezone, iso);
state.birth.place = s.label; state.birth.latitude = s.latitude;
state.birth.longitude = s.longitude; state.birth.timezone = s.timezone;
state.birth.tzOffsetMinutes = off; state.suggestOpen = false;
render();
} }, [ h("span", null, s.label), h("small", null, s.timezone + " · " + s.latitude.toFixed(2) + "°, " + s.longitude.toFixed(2) + "°") ]));
ul.appendChild(li);
});
}
function tzOffset(tz, iso) {
try {
var d = new Date(iso);
var fmt = new Intl.DateTimeFormat("en-US", { timeZone: tz, timeZoneName: "shortOffset" });
var parts = fmt.formatToParts(d);
var p = (parts.filter(function(x){return x.type==="timeZoneName";})[0] || { value: "GMT+0" }).value;
var m = /GMT([+-])(\d{1,2})(?::?(\d{2}))?/.exec(p);
if (!m) return 0;
var sign = m[1] === "-" ? -1 : 1;
return sign * (parseInt(m[2]||"0",10)*60 + parseInt(m[3]||"0",10));
} catch (e) { return 0; }
}
function nextFromBirth() {
var b = state.birth;
if (!b.name.trim() || b.name.trim().length < 2) { state.error = "Please enter your full name."; return render(); }
if (!b.date) { state.error = "Please pick your date of birth."; return render(); }
if (!b.time) { state.error = "Please enter your time of birth."; return render(); }
if (b.latitude == null || b.longitude == null) { state.error = "Please pick your city of birth from the suggestions."; return render(); }
state.error = null;
state.contact.name = state.contact.name || b.name;
state.step = 2; render();
window.scrollTo({ top: root.offsetTop - 30, behavior: "smooth" });
}
function renderContact() {
var c = state.contact;
return h("div", { class: "sk-card", style: "position:relative;overflow:hidden;" }, [
h("div", { class: "sk-mandala" }),
h("div", { style: "position:relative;" }, [
h("div", { style: "text-align:center;margin-bottom:16px;" }, h("span", { class: "sk-chip" }, "Step 2 · Prapti Vivaran")),
h("h2", { class: "sk-title" }, "Where should we send your Kundli?"),
h("p", { class: "sk-caption", style: "max-width:520px;margin:0 auto 20px;" }, "Your full birth chart is ready. Add your contact details below and we'll unlock the download — plus a personalised rudraksha recommendation from Satyug Lifestyle."),
h("div", { class: "sk-grid" }, [
h("div", { style: "grid-column:1/-1;" }, [ h("label", { class: "sk-label" }, "Full Name"), h("input", { class: "sk-input", value: c.name, oninput: function(e) { state.contact.name = e.target.value; } }) ]),
h("div", null, [ h("label", { class: "sk-label" }, "Email Address"), h("input", { class: "sk-input", type: "email", placeholder: "you@example.com", value: c.email, oninput: function(e) { state.contact.email = e.target.value; } }) ]),
h("div", null, [ h("label", { class: "sk-label" }, "Mobile Number"), h("input", { class: "sk-input", type: "tel", placeholder: "+91 98xxxxxxxx", value: c.phone, oninput: function(e) { state.contact.phone = e.target.value; } }) ])
]),
h("label", { class: "sk-check" }, [ h("input", { type: "checkbox", checked: c.whatsapp, onchange: function(e) { state.contact.whatsapp = e.target.checked; } }), h("span", null, "Send my daily horoscope & muhurat updates on WhatsApp.") ]),
h("label", { class: "sk-check" }, [ h("input", { type: "checkbox", checked: c.consent, onchange: function(e) { state.contact.consent = e.target.checked; } }), h("span", null, "I agree to receive my Kundli and occasional offers from Satyug Lifestyle. Unsubscribe anytime.") ]),
state.error ? h("p", { class: "sk-error" }, state.error) : null,
h("div", { class: "sk-actions" }, [
h("button", { class: "sk-btn-ghost", onclick: function() { state.step = 1; render(); } }, "← Back"),
h("button", { class: "sk-btn-gold", disabled: state.submitting, onclick: submitContact }, state.submitting ? [h("span", { class: "sk-spinner" }), " Casting the chart…"] : "Reveal My Kundli")
])
])
]);
}
function submitContact() {
var c = state.contact;
if (!c.name.trim() || c.name.trim().length < 2) { state.error = "Please enter your name."; return render(); }
if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(c.email)) { state.error = "Please enter a valid email address."; return render(); }
var digits = (c.phone || "").replace(/\D/g, "");
if (digits.length < 7 || digits.length > 15) { state.error = "Please enter a valid phone number."; return render(); }
if (!c.consent) { state.error = "Please agree to receive your Kundli by email."; return render(); }
state.error = null;
state.submitting = true; render();
var k = computeKundli({ name: c.name, date: state.birth.date, time: state.birth.time, place: state.birth.place, latitude: state.birth.latitude, longitude: state.birth.longitude, tzOffsetMinutes: state.birth.tzOffsetMinutes });
var fd = new FormData();
fd.append("form_type", "contact");
fd.append("utf8", "✓");
fd.append("contact[name]", c.name);
fd.append("contact[email]", c.email);
fd.append("contact[phone]", c.phone);
fd.append("contact[body]",
"🕉  Free Kundli request from " + c.name + "\n\n" +
"Birth: " + state.birth.date + " " + state.birth.time + " (offset " + ((state.birth.tzOffsetMinutes||0)/60) + "h)\n" +
"Place: " + state.birth.place + " (" + state.birth.latitude + ", " + state.birth.longitude + ")\n" +
"WhatsApp opt-in: " + (c.whatsapp ? "yes" : "no") + "\n\n" +
"— Kundli summary —\n" +
"Ascendant: " + k.ascendant.en + " · Moon: " + k.moon.en + " (" + k.moon.nak + " pada " + k.moon.pada + ")\n" +
"Sun: " + k.sun.en + " · Current Mahadasha: " + k.dashas.current.lord + " → " + k.dashas.currentAntar.lord + " (antar)\n" +
"Panchang: " + k.panchang.tithi + " · " + k.panchang.karana + " · " + k.panchang.yoga + " · " + k.panchang.vara + "\n" +
"Sunrise " + k.panchang.sunrise + " · Sunset " + k.panchang.sunset + "\n" +
"Avakhada: Varna " + k.avakhada.varna + " · Yoni " + k.avakhada.yoni + " · Gan " + k.avakhada.gan + " · Nadi " + k.avakhada.nadi + " · Name letter '" + k.avakhada.alphabet + "'"
);
fetch("/contact", { method: "POST", body: fd, credentials: "same-origin", redirect: "follow" })
.then(function() {}).catch(function() {})
.finally(function() {
state.kundli = k; state.submitting = false; state.step = 3; render();
window.scrollTo({ top: root.offsetTop - 30, behavior: "smooth" });
});
}
function renderResults() {
var k = state.kundli;
return h("div", null, [
h("div", { style: "text-align:center;" }, [
h("span", { class: "sk-chip" }, "Step 3 · Aapki Kundli"),
h("h2", { class: "sk-name-hero" }, k.input.name),
h("p", { class: "sk-birth-line" }, k.input.date + " · " + k.input.time + " · " + k.input.place),
h("div", { class: "sk-divider" })
]),
h("div", { class: "sk-grid3" }, [
h("div", { class: "sk-card" }, [
h("div", { style: "display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;" }, [
h("h3", { class: "sk-title", style: "text-align:left;margin:0;font-size:20px;" }, "Rashi Chart · राशि चक्र"),
h("span", { style: "font-size:12px;color:var(--sk-muted);" }, "North Indian")
]),
h("div", { class: "sk-chart-wrap", html: renderChartSVG(k) }),
h("p", { style: "text-align:center;font-size:12px;color:var(--sk-muted);margin-top:12px;" }, "Ayanamsa (Lahiri): " + k.ayanamsa.toFixed(4) + "°")
]),
h("div", { class: "sk-facts" }, [
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Ascendant / Lagna"), h("div", { class: "v" }, k.ascendant.en + " " + k.ascendant.sa), h("div", { class: "m" }, "Ruler: " + k.ascendant.lord + " · Element: " + k.ascendant.el) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Moon Sign / Rashi"), h("div", { class: "v" }, k.moon.en + " " + k.moon.sa), h("div", { class: "m" }, "Nakshatra: " + k.moon.nak + " · Pada " + k.moon.pada) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Current Dasha"), h("div", { class: "v" }, k.dashas.current.lord + " → " + k.dashas.currentAntar.lord), h("div", { class: "m" }, "Mahadasha " + new Date(k.dashas.current.from).toLocaleDateString() + " → " + new Date(k.dashas.current.to).toLocaleDateString()) ])
])
]),
h("div", { class: "sk-card" }, [
h("h3", { class: "sk-title", style: "text-align:left;margin:0 0 12px;font-size:20px;" }, "Panchang · पञ्चाङ्ग"),
h("div", { class: "sk-facts", style: "grid-template-columns:repeat(auto-fill,minmax(160px,1fr));" }, [
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Tithi"), h("div", { class: "v" }, k.panchang.tithi) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Vara (Day)"), h("div", { class: "v" }, k.panchang.vara) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Nakshatra"), h("div", { class: "v" }, k.moon.nak), h("div", { class: "m" }, "Pada " + k.moon.pada + " · Lord " + k.moon.lord) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Yoga"), h("div", { class: "v" }, k.panchang.yoga) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Karana"), h("div", { class: "v" }, k.panchang.karana) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Sunrise"), h("div", { class: "v" }, k.panchang.sunrise), h("div", { class: "m" }, "Sunset " + k.panchang.sunset) ])
])
]),
h("div", { class: "sk-card" }, [
h("h3", { class: "sk-title", style: "text-align:left;margin:0 0 12px;font-size:20px;" }, "Today's Horoscope for you"),
h("p", { style: "font-size:18px;line-height:1.6;color:var(--sk-ink);margin:0;" }, k.horoscope)
]),
h("div", { class: "sk-card" }, [
h("h3", { class: "sk-title", style: "text-align:left;margin:0 0 12px;font-size:20px;" }, "Planetary Positions · ग्रह स्थिति"),
renderPlanetTable(k)
]),
h("div", { class: "sk-card" }, [
h("h3", { class: "sk-title", style: "text-align:left;margin:0 0 12px;font-size:20px;" }, "Avakhada Details · अवकहडा"),
h("p", { style: "color:var(--sk-muted);font-size:14px;margin:0 0 14px;" }, "Traditional attributes from your Moon rashi and nakshatra — used for matchmaking (kundli milan), name-choosing, and personality analysis."),
h("div", { class: "sk-facts", style: "grid-template-columns:repeat(auto-fill,minmax(150px,1fr));" }, [
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Varna"), h("div", { class: "v" }, k.avakhada.varna) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Vashya"), h("div", { class: "v" }, k.avakhada.vashya) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Yoni"), h("div", { class: "v" }, k.avakhada.yoni) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Gan"), h("div", { class: "v" }, k.avakhada.gan) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Nadi"), h("div", { class: "v" }, k.avakhada.nadi) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Sign Lord"), h("div", { class: "v" }, k.avakhada.signLord) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Nakshatra Lord"), h("div", { class: "v" }, k.avakhada.nakshatraLord) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Charan"), h("div", { class: "v" }, String(k.avakhada.charan)) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Tatva"), h("div", { class: "v" }, k.avakhada.tatva) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Paya"), h("div", { class: "v" }, k.avakhada.paya) ]),
h("div", { class: "sk-fact" }, [ h("div", { class: "k" }, "Name Alphabet"), h("div", { class: "v" }, k.avakhada.alphabet), h("div", { class: "m" }, "First sound of your birth star") ])
])
]),
h("div", { class: "sk-doshas" }, ["manglik","kaal","sade"].map(function(key) {
var d = k.doshas[key]; var name = key === "manglik" ? "Manglik" : key === "kaal" ? "Kaal Sarp" : "Sade Sati";
return h("div", { class: "sk-dosha " + (d.on ? "on" : "off") }, [
h("div", { class: "head" }, [ h("span", { style: "font-family:Cinzel,Georgia,serif;font-size:12px;letter-spacing:.18em;text-transform:uppercase;color:var(--sk-gold);" }, name), h("span", { class: "badge" }, d.on ? "Present" : "Not present") ]),
h("p", { style: "font-size:14px;color:var(--sk-ink);margin:0;line-height:1.5;" }, d.reason)
]);
})),
h("div", { class: "sk-card" }, [
h("h3", { class: "sk-title", style: "text-align:left;margin:0 0 12px;font-size:20px;" }, "Personality Reading · Lagna Phal"),
h("p", { style: "margin:0 0 8px;" }, [ h("span", { style: "color:var(--sk-gold);font-family:Cinzel;font-size:11px;letter-spacing:.18em;text-transform:uppercase;margin-right:8px;" }, "Strengths"), k.traits.s ]),
h("p", { style: "margin:0 0 8px;" }, [ h("span", { style: "color:var(--sk-gold);font-family:Cinzel;font-size:11px;letter-spacing:.18em;text-transform:uppercase;margin-right:8px;" }, "Watch for"), k.traits.c ]),
h("p", { style: "margin:0;" }, [ h("span", { style: "color:var(--sk-gold);font-family:Cinzel;font-size:11px;letter-spacing:.18em;text-transform:uppercase;margin-right:8px;" }, "Life path"), k.traits.l ])
]),
h("div", { class: "sk-card" }, [
h("h3", { class: "sk-title", style: "text-align:left;margin:0 0 12px;font-size:20px;" }, "Current Mahadasha → Antardasha (Bhukti)"),
h("p", { style: "color:var(--sk-muted);font-size:14px;margin:0 0 12px;" }, "You are running the " + k.dashas.current.lord + " Mahadasha. Inside it, the current sub-period (antardasha / bhukti) is " + k.dashas.currentAntar.lord + "."),
renderAntardashaTable(k.dashas.current.antardashas)
]),
h("div", { class: "sk-card" }, [
h("h3", { class: "sk-title", style: "text-align:left;margin:0 0 12px;font-size:20px;" }, "Vimshottari Dasha Timeline"),
h("p", { style: "color:var(--sk-muted);font-size:13px;margin:0 0 10px;" }, "Click a mahadasha to see its antardashas."),
renderDashaTable(k)
]),
h("div", { class: "sk-card" }, [
h("div", { style: "display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;" }, [
h("h3", { class: "sk-title", style: "text-align:left;margin:0;font-size:20px;" }, "Chosen for you · Satyug Lifestyle"),
h("span", { style: "font-size:12px;color:var(--sk-muted);" }, "Based on " + k.moon.en + " moon")
]),
h("div", { class: "sk-recs" }, k.recs.map(function(r) {
return h("a", { class: "sk-rec", href: "/search?q=" + encodeURIComponent(r.q), target: "_top" }, [ h("div", { class: "t" }, r.t + " →"), h("div", { class: "r" }, r.r) ]);
}))
]),
h("div", { class: "sk-actions", style: "margin-top:24px;flex-direction:column;" }, [
h("button", { class: "sk-btn-gold", onclick: downloadPdf }, "⬇  Download Full Kundli PDF"),
h("button", { class: "sk-btn-ghost", onclick: function() {
state.step = 1; state.birth = { name: "", date: "", time: "", place: "", latitude: null, longitude: null, tzOffsetMinutes: null, timezone: "" };
state.contact = { name: "", email: "", phone: "", whatsapp: true, consent: true };
state.kundli = null; state.dashaOpen = null; render();
} }, "Cast another chart")
])
]);
}
function renderPlanetTable(k) {
var wrap = h("div", { class: "sk-table-wrap" });
var t = h("table", { class: "sk-table" });
var thead = h("thead", null, h("tr", null, [ h("th", null, "Planet"), h("th", null, "Rashi"), h("th", null, "Degree"), h("th", null, "House"), h("th", null, "Nakshatra"), h("th", null, "Pada") ]));
var tbody = h("tbody", null, k.planets.map(function(p) {
return h("tr", null, [
h("td", null, [ h("span", { class: "sk-planet-dot", style: "background:" + p.c + ";" }), p.en + (p.retro ? " ℞" : "") ]),
h("td", null, p.rName + " " + p.rSa),
h("td", null, fmtDeg(p.lon)),
h("td", null, String(p.house)),
h("td", null, p.nak),
h("td", null, String(p.pada))
]);
}));
t.appendChild(thead); t.appendChild(tbody);
wrap.appendChild(t);
return wrap;
}
function renderAntardashaTable(list) {
var now = new Date();
var wrap = h("div", { class: "sk-table-wrap" });
var t = h("table", { class: "sk-table" });
t.appendChild(h("thead", null, h("tr", null, [ h("th", null, "Antar Lord"), h("th", null, "From"), h("th", null, "To"), h("th", null, "Duration") ])));
t.appendChild(h("tbody", null, list.map(function(a) {
var isNow = new Date(a.from) <= now && new Date(a.to) > now;
var years = a.years;
var months = Math.round(years * 12 * 10) / 10;
var dur = years >= 1 ? years.toFixed(2) + " yrs" : months.toFixed(1) + " mo";
return h("tr", { class: isNow ? "sk-current" : "" }, [
h("td", null, a.lord + (isNow ? " (current)" : "")),
h("td", null, new Date(a.from).toLocaleDateString()),
h("td", null, new Date(a.to).toLocaleDateString()),
h("td", null, dur)
]);
})));
wrap.appendChild(t);
return wrap;
}
function renderDashaTable(k) {
var now = new Date();
var wrap = h("div", { class: "sk-table-wrap" });
var t = h("table", { class: "sk-table" });
t.appendChild(h("thead", null, h("tr", null, [h("th", null, "Lord"), h("th", null, "From"), h("th", null, "To"), h("th", null, "Years"), h("th", null, "")])));
var tbody = h("tbody");
k.dashas.sequence.slice(0, 9).forEach(function(d, idx) {
var isNow = new Date(d.from) <= now && new Date(d.to) > now;
var open = state.dashaOpen === idx;
tbody.appendChild(h("tr", { class: isNow ? "sk-current" : "", style: "cursor:pointer;", onclick: function() { state.dashaOpen = open ? null : idx; render(); } }, [
h("td", null, d.lord + (isNow ? " (current)" : "")),
h("td", null, new Date(d.from).toLocaleDateString()),
h("td", null, new Date(d.to).toLocaleDateString()),
h("td", null, String(d.years)),
h("td", null, open ? "▲" : "▼")
]));
if (open && d.antardashas) {
var inner = h("tr", null, h("td", { colspan: 5, style: "padding:12px 0 18px;" }, renderAntardashaTable(d.antardashas)));
tbody.appendChild(inner);
}
});
t.appendChild(tbody);
wrap.appendChild(t);
return wrap;
}
function renderChartSVG(k) {
var size = 400, m = 12, s = size - m * 2, mid = size / 2;
var houseCenters = [
[mid, mid - s/4],[mid - s/4, mid - s/3],[mid - s/3, mid - s/4],[mid - s/4, mid],
[mid - s/3, mid + s/4],[mid - s/4, mid + s/3],[mid, mid + s/4],[mid + s/4, mid + s/3],
[mid + s/3, mid + s/4],[mid + s/4, mid],[mid + s/3, mid - s/4],[mid + s/4, mid - s/3]
];
var grouped = {};
k.planets.forEach(function(p) { (grouped[p.house] = grouped[p.house] || []).push(p.s + (p.retro ? "℞" : "")); });
var asc = k.ascendant.rIdx + 1;
var svg = ['<svg viewBox="0 0 ' + size + ' ' + size + '" style="filter:drop-shadow(0 0 30px rgba(212,165,68,.25));">'];
svg.push('<defs><linearGradient id="skCell" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#151020"/><stop offset="100%" stop-color="#0b0710"/></linearGradient></defs>');
svg.push('<rect x="' + m + '" y="' + m + '" width="' + s + '" height="' + s + '" fill="url(#skCell)" stroke="#d4a544" stroke-width="1.5"/>');
svg.push('<line x1="' + m + '" y1="' + m + '" x2="' + (m+s) + '" y2="' + (m+s) + '" stroke="#d4a544" stroke-width="1"/>');
svg.push('<line x1="' + (m+s) + '" y1="' + m + '" x2="' + m + '" y2="' + (m+s) + '" stroke="#d4a544" stroke-width="1"/>');
svg.push('<polygon points="' + mid + ',' + m + ' ' + (m+s) + ',' + mid + ' ' + mid + ',' + (m+s) + ' ' + m + ',' + mid + '" fill="none" stroke="#d4a544" stroke-width="1.25"/>');
houseCenters.forEach(function(c, i) {
var houseNum = i + 1;
var rashiNum = ((asc + i - 1) % 12) + 1;
var pl = grouped[houseNum] || [];
svg.push('<text x="' + c[0] + '" y="' + (c[1] - 8) + '" text-anchor="middle" fill="rgba(163,151,179,.7)" font-family="Cinzel,serif" font-size="12">' + rashiNum + '</text>');
if (pl.length) svg.push('<text x="' + c[0] + '" y="' + (c[1] + 10) + '" text-anchor="middle" fill="#f6d78a" font-family="Cinzel,serif" font-size="12" font-weight="600">' + pl.join(" ") + '</text>');
});
svg.push('</svg>');
return svg.join("");
}
function downloadPdf() {
var existing = document.querySelector(".sk-print-root");
if (existing) existing.remove();
var container = document.createElement("div");
container.className = "sk-print-root sk-root";
container.style.display = "none";
container.innerHTML = root.innerHTML;
document.body.appendChild(container);
window.print();
setTimeout(function() { container.remove(); }, 1000);
}
render();
})(window.SK = window.SK || {});
